const variables = {
  // Fonts
  fontFamily: {
    special: 'Neue Pixel Sans',
  },

  color: {
    // green
    green: '#28D18A',

    // blue
    blueDark: '#0D1927',
    blue: '#2E6EB8',
    blueShadow: '#214671',

    // baby blue
    babyBlue: '#80B1EA',
    babyBlueShadow: '#4986CD',

    // yellow
    yellow: '#DFC254',
    yellowShadow: '#857431',

    // white
    white: '#d3e2f5',
    whiteShadow: '#6B9CD6',

    // redd
    red: '#B04141',
    redShadow: '#581F1F',

    // pokemon types
    normal: '#808f3f',
    normalShadow: '#4b5424',
    fire: '#c96e26',
    fireShadow: '#7a4217',
    water: '#4ba5fa',
    waterShadow: '#2c6aa3',
    grass: '#66ba4c',
    grassShadow: '#41822e',
    electric: '#9e8639',
    electricShadow: '#705f26',
    ice: '#3a9dc7',
    iceShadow: '#276782',
    fighting: '#8f2e3c',
    fightingShadow: '#5c1a24',
    poison: '#7c4f9c',
    poisonShadow: '#53316b',
    ground: '#807234',
    groundShadow: '#5e5323',
    flying: '#3f3182',
    flyingShadow: '#281e57',
    psychic: '#94466e',
    psychicShadow: '#6b2e4e',
    bug: '#648f3f',
    bugShadow: '#48692b',
    rock: '#756d49',
    rockShadow: '#4d472d',
    ghost: '#4a4178',
    ghostShadow: '#30294f',
    dark: '#6e653d',
    darkShadow: '#4f482a',
    dragon: '#44326e',
    dragonShadow: '#322452',
    steel: '#524b63',
    steelShadow: '#3b354a',
    fairy: '#6e4259',
    fairyShadow: '#543143',
  },
};

export default variables;
